import React from 'react';
import { Icon, Item, Label } from 'semantic-ui-react';

const SelectedPassengersLabels = ({ selectedPassengers, onPassengerDelete }) =>
  selectedPassengers.length > 0
    ? selectedPassengers.map(passenger => (
        <Item key={passenger.passengerTicketId} style={{ marginRight: 4 }}>
          <Label size="small">
            {passenger.text}
            <Icon
              name="delete"
              onClick={() => onPassengerDelete(passenger)}
            />
          </Label>
        </Item>
      ))
    : null;

export default SelectedPassengersLabels;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/AddPassenger/SelectedPassengerLabels.js